package com.nonopn.skywatcher.common.app.pages.sentinels

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Divider
import androidx.compose.material.ripple
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.EnsureAppModel
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.design.widgets.DefaultCard
import com.nonopn.skywatcher.design.widgets.defaultCardBackground
import com.nonopn.skywatcher.design.widgets.defaultScrollBackground
import com.nonopn.skywatcher.design.widgets.verticalColumnScrollbar
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.TextNormal

@Composable
fun LoadDetectionScreen(modifier: Modifier) = EnsureAppModel { appModel ->
    val states by appModel.states.collectAsState()
    val detections = states.thunderDetections

    val maxHeight = with(LocalDensity.current) {
        ((50 * detections.size) * density).toDp()
    }

    CheckPushNotificationCompose()

    Column(
        modifier,
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        val scrollState = rememberScrollState()
        val scrollBackground = defaultScrollBackground()
        DefaultCard(
            modifier = Modifier
                .widthIn(max = 300.dp)
                .heightIn(max = maxHeight),
            backgroundColor = defaultCardBackground(),
            columnModifier = Modifier.verticalScroll(scrollState)
                .verticalColumnScrollbar(
                    scrollState = scrollState,
                    scrollBarColor = scrollBackground
                )
        ) {
            detections.forEachIndexed { index, detection ->
                if (index > 0) {
                    Divider()
                }

                RenderDetectionButton(detection) {
                    appModel.selectThunderDetection(detection)
                }
            }
        }
    }
}

@Composable
private fun RenderDetectionButton(detection: ThunderDetectionWithMetadata, onClick: () -> Unit) {
    Column(
        Modifier.fillMaxWidth()
            .height(50.dp)
            .clickable(
                onClick = onClick,
                interactionSource = remember { MutableInteractionSource() },
                indication = ripple()
            ),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        TextNormal(
            "Detection ${detection.detection.name}",
            textAlign = TextAlign.Center
        )
    }
}

@HotPreview(widthDp = 1200, heightDp = 800, darkMode = true)
@HotPreview(widthDp = 1200, heightDp = 800, darkMode = false)
@Composable
private fun MainScreenPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme(), isPreview = true) {
        LoadDetectionScreen(Modifier.fillMaxSize())
    }
}